import React from 'react';
import PropTypes from 'prop-types';

const Form = (props) => {
  const { children, contentRef, ...restProps } = props;

  const formProps = {
    // These are mainly default values for the server
    // rendering. Otherwise the form would submit potentially
    // sensitive data with the default GET method until the client
    // side code is loaded.
    method: 'post',
    action: '/',

    // allow content ref function to be passed to the form
    ref: contentRef,

    ...restProps,
  };
  return <form {...formProps}>{children}</form>;
};

Form.defaultProps = {
  id: null,
  children: null,
  className: null,
  contentRef: null,
  onSubmit: null,
};

const { func, node, string } = PropTypes;

Form.propTypes = {
  id: string,
  children: node,
  className: string,
  contentRef: func,
  onSubmit: func,
};

export default Form;
